// Add the CSS to the automated workflow
import "../css/style.css"

// Import custom JS here...
import EnergyWheel from "./energy-wheel"
import Journal from "./journal"
import Visionboard from "./visionboard"
import Account from "./account"
import WelcomeModal from "./welcome-modal"

var energyWheel = new EnergyWheel()
var journal = new Journal()
var visionboard = new Visionboard()
var account = new Account()
var welcomeModal = new WelcomeModal()
